import React, { useRef } from 'react'
import * as htmlToImage from 'html-to-image';
import { saveAs } from 'file-saver';
import bgimage from '../images/template.png'
export const Design = ({ athikaaram, kural_no, paal, iyal, line1, line2, explain }) => {
    const divRef = useRef(null);

    const convertToImage = () => {
        htmlToImage.toPng(divRef.current)
            .then(function (dataUrl) {
                // Convert data URL to Blob
                const blob = dataURLtoBlob(dataUrl);
                // Save the Blob as a file
                saveAs(blob, `kural-${kural_no}.png`);
            })
            .catch(function (error) {
                console.error('Oops, something went wrong!', error);
            });
    };

    // Function to convert Data URL to Blob
    const dataURLtoBlob = (dataUrl) => {
        const arr = dataUrl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    return (
        <>
            <button onClick={convertToImage}>Download to Image</button>
            <div className='position-relative' ref={divRef} style={{ width: 'fit-content' }}>
                <p className='athikaaram' >{athikaaram}</p>
                <p className='kural_no' >{kural_no}</p>
                <p className='paal' >{paal}</p>
                <p className='iyal' >{iyal}</p>
                <p className='line1' >{line1}</p>
                <p className='line2' >{line2}</p>
                <div className='explain'>
                    <p className='' >{explain}</p>
                    <p className='mv' >- டாக்டர் மு.வரதராசனார்</p>
                </div>
                <img src={bgimage} alt="" width="1380px" />
            </div>
        </>
    )
}
